<template>
  <section class="hero">
    <div>
      <h1>Time tracking and workforce management for any business</h1>
      <p class="lead">
      Track employee clock-ins, approve timesheets, record shift notes, and generate payroll-ready reports — all from one simple platform.
      </p>
      <RouterLink class="button" to="/pricing">Get started</RouterLink>
    </div>
    <div class="card">
      <h2>Get started in minutes</h2>
      <p>Any business can sign up, subscribe, and start managing employees immediately.</p>
      <ul>
        <li>GPS-based clock-in and clock-out from mobile app</li>
        <li>Automated timesheets</li>
        <li>Shift notes and activity logs</li>
        <li>Payroll-ready reports</li>
      </ul>
    </div>
  </section>
   <HowItworks />
<section class="mobile-apps">
  <h2>Mobile apps for employees</h2>

  <p>
    Employees can clock in, manage attendance, and track shifts using
    the JPFC Workforce mobile application.
  </p>

  <div class="store-buttons">
    <a
      href="https://apps.apple.com/us/app/jpfc-workforce/id6753688029"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="/app-store-badge.svg"
        alt="Download on the App Store"
      />
    </a>

    <a
      href="https://play.google.com/store/apps/details?id=com.thejacksonsplace.jpfcapp"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="/google-play-badge.svg"
        alt="Get it on Google Play"
      />
    </a>
  </div>

  <div class="mobile-app-note">
    Available for iOS and Android devices
  </div>
</section>
</template>
<script setup>
import HowItworks from '@/components/HowItworks.vue'
</script>
<style scoped>
.mobile-apps {
  padding: 4rem 1.5rem;
  text-align: center;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
}

.mobile-apps h2 {
  font-size: 2rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 1rem;
}

.mobile-apps p {
  max-width: 700px;
  margin: 0 auto 2rem;
  color: #6b7280;
  line-height: 1.7;
  font-size: 1rem;
}

.store-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.store-buttons a {
  display: inline-flex;
  transition: transform 0.2s ease;
}

.store-buttons a:hover {
  transform: translateY(-2px);
}

.store-buttons img {
  height: 58px;
  width: auto;
  object-fit: contain;
}

/* Optional small note */
.mobile-app-note {
  margin-top: 1.5rem;
  color: #9ca3af;
  font-size: 0.9rem;
}

/* Mobile */
@media (max-width: 768px) {
  .mobile-apps {
    padding: 3rem 1rem;
  }

  .mobile-apps h2 {
    font-size: 1.6rem;
  }

  .mobile-apps p {
    font-size: 0.95rem;
  }

  .store-buttons img {
    height: 52px;
  }
}
</style>
